module.exports = __webpack_public_path__ + "static/media/pumpkin.4a538071.svg";